export interface Testimonial {
  id: string;
  name: string;
  text: string;
  rating: number;
  avatar?: string;
  date: string;
}

export const testimonials: Testimonial[] = [
  {
    id: 't1',
    name: 'Sarah Mitchell',
    text: 'The best chai I have ever had outside of Afghanistan. The Ghalib Special Karak Chai is absolutely magical — you can taste the quality in every sip. The atmosphere is so warm and welcoming too.',
    rating: 5,
    date: 'July 2026',
  },
  {
    id: 't2',
    name: 'Omar Farooq',
    text: 'I come here every weekend with my family. The parathas are flaky perfection and the saffron chai reminds me of home. Ghalib Chai has become our little tradition.',
    rating: 5,
    date: 'June 2026',
  },
  {
    id: 't3',
    name: 'Emily Chen',
    text: 'The green tea shop is a hidden gem. I ordered the Premium Afghan Green Tea online and it arrived beautifully packaged. The flavor is so pure and fresh. Highly recommend!',
    rating: 5,
    date: 'August 2026',
  },
  {
    id: 't4',
    name: 'James Rodriguez',
    text: 'Discovered this place through a friend and now I am hooked. The Kashmiri Pink Tea is unlike anything I have ever tasted. The staff is incredibly friendly and the space is beautiful.',
    rating: 5,
    date: 'July 2026',
  },
  {
    id: 't5',
    name: 'Fatima Al-Rashid',
    text: 'As someone who grew up drinking chai, Ghalib Chai nails the authenticity. Their masala blend is perfectly balanced and the samosas are the best in the city.',
    rating: 5,
    date: 'May 2026',
  },
  {
    id: 't6',
    name: 'David Park',
    text: 'The jasmine green tea is my go-to afternoon pick-me-up. I also love that they sell their tea packs so I can enjoy it at home. Great quality, great service.',
    rating: 4,
    date: 'August 2026',
  },
];